// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.form-control[data-v-b823ce84] {\n  height: 43px;\n  border-radius: 0.25rem !important;\n}\n", ""]);
// Exports
module.exports = exports;
